import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Andreas Gohr
 * id 3BC78F10-A7C3-4F15-9328-138E35CFC259
 * name format-float-center
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/format-float-center.svg
 * tags
 * - Text / Content / Format 
 */
export const FormatFloatCenterIcon = createSvgIcon(<><path d="M9,7H15V13H9V7M3,3H21V5H3V3M3,15H21V17H3V15M3,19H17V21H3V19Z" /></>, 'FormatFloatCenterIcon');
export default FormatFloatCenterIcon